export default {
    tooltip: 'Attention: There is an updated version of this trend from TRENDONE.'
}
